import styled from 'styled-components';

export const TagRecordType = styled.div`
  font-size: 13px;
  font-weight: bold;
  margin-right: 0.5rem;
  padding: 2px 6px;
  border-radius: 6px;
  color: #fff;
  background-color: #4682b4;
  max-width: fit-content;
  margin: 0.5rem 0.5rem;
`;
